export enum CollectionOwnerType {
  Organization = 'organization',
  Taster = 'taster'
}
